import * as types from './mutation-types'

export default {
  [types.BOOTSTRAP_FORMS] (state, data) {
    state.islamicFinanceForm = data
  },
  [types.UPDATE_FORM] (state, data) {
    let pos = state.islamicFinanceForm.findIndex(form => form.id === data.id)
    state.islamicFinanceForm.splice(pos, 1)
    state.islamicFinanceForm = [data, ...state.islamicFinanceForm]
  }
}
